/**
 * PDF-specific handoff methods for the shared report builder.
 */
const build_entity_type_assignments = (entity_type_ids) =>
  entity_type_ids.map((entity_type_id) => ({
    entity_type: { id: entity_type_id },
  }));

const build_pdf_seed = (component) => ({
  name: component.template_name || "",
  description: component.template_description || "",
  save_as_template: component.save_as_template,
  entity_type_assignments: build_entity_type_assignments(
    component.template_entity_type_ids
  ),
});

export default {
  handle_output_format_change() {
    if (!this.is_pdf_output_format) {
      this.pdf_builder_template = null;
      return;
    }
    if (this.pdf_builder_template) {
      this.pdf_builder_render_key += 1;
      return;
    }
    this.current_step_key = "basics";
    this.pdf_builder_template = build_pdf_seed(this);
    this.pdf_builder_render_key += 1;
  },
  handle_pdf_builder_output_change(next_output_format_id) {
    this.selected_output_format_id = next_output_format_id;
    if (this.is_pdf_output_format) {
      return;
    }
    this.pdf_builder_template = null;
    this.pdf_builder_render_key += 1;
  },
  handle_pdf_builder_cancel() {
    this.selected_output_format_id = "";
    this.current_step_key = "basics";
    this.pdf_builder_template = null;
    this.pdf_builder_render_key += 1;
  },
  handle_pdf_template_saved(saved_template) {
    this.pdf_builder_template = saved_template || build_pdf_seed(this);
    this.pdf_builder_render_key += 1;
  },
  apply_pdf_template(template) {
    const pdf_output_format_id = this.get_lookup_id("output_formats", "pdf");
    this.template_name = template?.name || "";
    this.template_description = template?.description || "";
    this.pdf_builder_template = template || null;
    this.current_step_key = "basics";
    if (pdf_output_format_id) {
      this.selected_output_format_id = pdf_output_format_id;
      return;
    }
    this.pdf_builder_render_key += 1;
  },
};
